<div class="runs-panel">
  <div class="runs-panel__header">
    <h1 class="runs-panel__title">Run history</h1>
    <span class="runs-panel__subtitle" *ngIf="agent">{{ agent.name }}</span>
  </div>

  <div class="runs-panel__list" *ngIf="runs.length > 0">
    <div
      class="runs-panel__card"
      *ngFor="let run of runs; trackBy: trackByRunId"
      [class.runs-panel__card--current]="selectedRunId === run.id"
      (click)="onSelectRun(run)"
      (keydown.enter)="onSelectRun(run)"
      tabindex="0"
    >
      <div class="runs-panel__card-top">
        <span class="runs-panel__scenario">{{ run.scenario }}</span>
        <span class="runs-panel__status" [ngClass]="'runs-panel__status--' + statusMetaFor(run).tone">{{ statusMetaFor(run).label }}</span>
      </div>
      <div class="runs-panel__card-bottom">
        <span class="runs-panel__date">{{ runDate(run) }}</span>
        <span class="runs-panel__divider">·</span>
        <span class="runs-panel__outcome">{{ run.outcome }}</span>
      </div>
    </div>
  </div>

  <deo-panel-state
    *ngIf="runs.length === 0"
    mode="empty"
    icon="assets/icons/chat.svg"
    [title]="agent ? agent.name + ' has not recorded any runs yet' : 'No runs found'"
  ></deo-panel-state>
</div>
